import { graphql } from "@/api/graphql/types/gql";

export const UpdateAgentQuery = graphql(`
  mutation UpdateAgent($request: AccountsMsUpdateSupportUserRequest) {
    AccountsMsUpdateSupportUser(request: $request)
  }
`);
